import type { Response } from 'express';
import { HTTPStatusCode } from '@sbt-web/network/types';
import { SearchState } from '@/reducers/search';
import { registerError } from '@/tools/errorHelpers';
import { ListingHelper } from '@/tools/search/ListingHelper';

export const geogosResponseHandler = async (
  Helper: ListingHelper,
  search: SearchState,
  res?: Response
): Promise<boolean> => {
  const [geoStatus, errorMessage] = await Helper.checkGeoThenDispatch(search);
  if (geoStatus !== HTTPStatusCode.OK) {
    registerError(res, geoStatus, 'FATAL', {
      message: new Error(errorMessage),
      service: 'GEOGOS',
    });
    return false;
  }
  return true;
};
